import React from 'react';
import { V3KYCMobilePages as Pages } from 'spa/constants/VerificationConstants';
import MobilePage from '../../components/MobilePage';

const SMSCodeSuccessPage = () => (
  <MobilePage title="SMS Code Success" ctaText="Continue" nextPage={Pages.INDIVIDUAL_DETAILS} />
);

export default SMSCodeSuccessPage;
